import { callApi } from '../middleware/api';

export const fetchCallbackEnquiries = () => callApi('/api/callback', 'get');
export const fetchPendingOrdersCount = () => callApi('/api/orders/pending', 'get');


// WEBPACK FOOTER //
// ./src/sagas/api.js